import React from 'react'
import { SaveButton } from '../../../../../../../../../itrust_common/components/others'
import { connect, useDispatch } from 'react-redux'
import { visionInsuranceClaimFormEdit } from '../../../../../../../../../redux/actions/addOns/rpa/vision_insurance/visionInsuranceClaimFormAction'

function EyeMedFormButton(props) {
  const { disable, saving, buttonClasses, backStep, visionInsuranceClaimForm, isFinalScreen, backModule, editing: { activeTab }, currentModule, actionLabel } = props
  const dispatch = useDispatch()
  const activeModulesArr = (visionInsuranceClaimForm?.eligibility?.data || []).map(item => item.active && item.service_type ? item.service_type : '')

  const handleBackClick = () => {
    let activeTab, activeModule;

    if (currentModule === 'Contact Lens Fit and Follow-up') {
      if (activeModulesArr.includes('Exam')) {
        activeTab = visionInsuranceClaimForm.exams.exam.is_cpt2_selected == 'no' ? 2 : 3;
        activeModule = 'Exam';
      }
      else {
        activeTab = 'first';
        activeModule = '';
      }
    }
    else if (currentModule === 'Frame') {
      if (activeModulesArr.includes('Contact Lens Fit and Follow-up')) {
        activeTab = 2;
        activeModule = 'Contact Lens Fit and Follow-up';
      }
      else if (activeModulesArr.includes('Exam')) {
        activeTab = visionInsuranceClaimForm.exams.exam.is_cpt2_selected == 'no' ? 2 : 3;
        activeModule = 'Exam';
      }
      else {
        activeTab = 'first';
        activeModule = '';
      }
    }
    else if (currentModule === 'Lenses') {
      if (activeModulesArr.includes('Frame')) {
        activeTab = 3;
        activeModule = 'Frame';
      }
      else if (activeModulesArr.includes('Contact Lens Fit and Follow-up')) {
        activeTab = 2;
        activeModule = 'Contact Lens Fit and Follow-up';
      }
      else if (activeModulesArr.includes('Exam')) {
        activeTab = visionInsuranceClaimForm.exams.exam.is_cpt2_selected == 'no' ? 2 : 3;
        activeModule = 'Exam';
      }
      else {
        activeTab = 'first';
        activeModule = '';
      }
    }
    else if (isFinalScreen) {
      if (activeModulesArr.includes('Lenses')) {
        activeTab = 2;
        activeModule = 'Lenses';
      }
      else if (activeModulesArr.includes('Frame')) {
        activeTab = 3;
        activeModule = 'Frame';
      }
      else if (activeModulesArr.includes('Contact Lens Fit and Follow-up')) {
        activeTab = 2;
        activeModule = 'Contact Lens Fit and Follow-up';
      }
      else if (activeModulesArr.includes('Exam')) {
        activeTab = visionInsuranceClaimForm.exams.exam.is_cpt2_selected == 'no' ? 2 : 3;
        activeModule = 'Exam';
      }
    }
    else {
      activeTab = backStep;
      activeModule = backModule ?? '';
    }
    dispatch(visionInsuranceClaimFormEdit({ activeTab, activeModule }));
  };


  const showLensesFinalNote = isFinalScreen && activeModulesArr.includes('Lenses')

  const actionButtons = (
    <>
      {activeTab !== 'first' && <button type="button" className={`btn btn-outline-primary mr-5 px-7 ${disable ? 'disabled' : ''}`} onClick={handleBackClick}>Back</button>}
      <SaveButton saving={saving} buttonClasses={`px-7 ${buttonClasses} ${disable ? 'disabled' : ''}`} label={isFinalScreen ? 'Save' : (actionLabel || 'Next')} />
    </>
  )

  return (
    <div className={`d-flex mt-6 ${showLensesFinalNote ? 'align-items-center justify-content-between' : 'justify-content-end'} ${saving ? 'disabled' : ''}`}>
      {showLensesFinalNote && (
        <span className="text-muted mb-0 mr-5">
          Note: All charges are listed here, but only applicable charges will be applied.
        </span>
      )}
      {showLensesFinalNote ? <div className="d-flex">{actionButtons}</div> : actionButtons}
    </div>
  )
}

const mapStateToProps = (state) => {
  const { visionInsuranceClaimForm: { visionInsuranceClaimForm, saving, editing } } = state

  return {
    visionInsuranceClaimForm,
    saving,
    editing
  }
}

export default connect(mapStateToProps)(EyeMedFormButton)
